import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = {
  key: 0,
  class: "col-md-6 col-xxl-6 col-sm-6 mb-10"
}
const _hoisted_7 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_9 = { class: "table" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { key: 5 }
const _hoisted_16 = { key: 6 }
const _hoisted_17 = {
  key: 1,
  class: "col-md-6 col-xxl-6 col-sm-6 mb-10"
}
const _hoisted_18 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_19 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_20 = { class: "table" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "col-md-12" }
const _hoisted_25 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "resiliationForm",
        onSubmit: _ctx.addResiliation,
        "validation-schema": _ctx.resiliationSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Abonnement "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "abonnement" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      placeholder: "Rechercher un abonnement",
                      "filter-results": false,
                      "min-chars": 3,
                      "resolve-on-load": false,
                      delay: 0,
                      searchable: true,
                      "options-limit": 300,
                      options: async (query) => {
                   return await _ctx.fetchAbonnements(query)
                  },
                      noResultText: "Aucun enregistrement trouvé",
                      noOptionsText: "Tapez au moins trois caractères",
                      onSelect: _ctx.handleObjetInput
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "onSelect"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "abonnement",
                  class: "text-danger"
                })
              ])
            ]),
            (_ctx.showDetails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "text-black fw-bold mb-10" }, "Information sur l'abonnement", -1)),
                      _createElementVNode("table", _hoisted_9, [
                        _createElementVNode("tbody", null, [
                          (_ctx.abonnement?.refAbo)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                                _cache[1] || (_cache[1] = _createElementVNode("td", null, "Référence", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.refAbo), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.abonnement?.demande?.refDemande)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Demande", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.demande.refDemande), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.abonnement?.adresseVirtuelle)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                                _cache[3] || (_cache[3] = _createElementVNode("td", null, "Adresse virtuelle", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.adresseVirtuelle), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.abonnement?.boite?.adressePostale?.adresse_postale)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                                _cache[4] || (_cache[4] = _createElementVNode("td", null, "Adresse postale", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite.adressePostale.adresse_postale), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.abonnement?.adresseVirtuelle)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                                _cache[5] || (_cache[5] = _createElementVNode("td", null, "Numéro", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.numero), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.abonnement?.boite)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                                _cache[6] || (_cache[6] = _createElementVNode("td", null, "Boite", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite?.refBoite), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.abonnement?.bureau?.nom)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                                _cache[7] || (_cache[7] = _createElementVNode("td", null, "Agence", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.bureau?.nom), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showDetails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "text-black fw-bold mb-10" }, "Information sur l'abonné", -1)),
                      _createElementVNode("table", _hoisted_20, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("td", null, "Nom et prénom", -1)),
                            _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.nomComplet), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[10] || (_cache[10] = _createElementVNode("td", null, "Nationalité", -1)),
                            _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.nationalite), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[11] || (_cache[11] = _createElementVNode("td", null, "Téléphone", -1)),
                            _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.telephone), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[12] || (_cache[12] = _createElementVNode("td", null, "Sexe", -1)),
                            _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.sexe), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Motif "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "motif",
                  as: "textarea",
                  cols: "30",
                  rows: "12",
                  placeholder: "Entrer les infos supplémentaitres",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field}) => [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control shadow-none rounded-0 text-black",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, null, 8, _hoisted_23), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "motif",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[16] || (_cache[16] = _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit"
                }, " Résilier l'abonnement ", -1)),
                _createVNode(_component_router_link, {
                  to: "/liste-resiliations",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}